import { signOutService } from './user.service';

const authToken = () => {
  const tokenStorage = localStorage.getItem('token');

  const token: string = tokenStorage ? JSON.parse(tokenStorage) : '';

  if (token) {
    return token;
  }
  signOutService();
};

export default authToken;
